import { z } from "zod";

export const GoodVibesVisibilitySchema = z.enum(["all", "public", "direct"]);
export type GoodVibesVisibility = z.infer<typeof GoodVibesVisibilitySchema>;

export const DEFAULT_GOOD_VIBES_VISIBILITY: GoodVibesVisibility = "all";
